const a = "_wrapper_1nkha_1", n = "_heading_1nkha_7", p = "_buttonWrapper_1nkha_10", r = {
  wrapper: a,
  heading: n,
  buttonWrapper: p
};
export {
  p as buttonWrapper,
  r as default,
  n as heading,
  a as wrapper
};
